import { EditGridColumnType } from "../../../components/FinalMolGrid/libs/data/editGridColumnType";
import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const membershipPricingTableConfig = {
    columns: [
        {
            name: "Category",
            fieldName: "category",
            allowShort: false,
            colStyle: {
                width: "10%",
                textAlign: "center",
            }
        },
        {
            name: "Admission Fee",
            fieldName: "admissionFee",
            colType: GridColumnType.MONEY,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Admission Fee",
                editColFieldName: "admissionFee",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Admission Fee is required." },
                ],
            },
            colStyle: {
                textAlign: "right",
            },
            allowShort: false
        },
        {
            name: "Application Fee",
            fieldName: "applicationFee",
            colType: GridColumnType.MONEY,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Application Fee",
                editColFieldName: "applicationFee",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Application Fee is required." },
                ],
            },
            colStyle: {
                textAlign: "right",
            },
            allowShort: false
        },
        {
            name: "Annual Subscription Fee",
            fieldName: "annualSubscriptionFee",
            colType: GridColumnType.MONEY,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Annual Subscription Fee",
                editColFieldName: "annualSubscriptionFee",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Annual Subsctiption Fee is required." },
                ],
            },
            colStyle: {
                textAlign: "right",
            },
            allowShort: false
        },
        {
            name: "Administration Fee",
            fieldName: "administrationFee",
            colType: GridColumnType.MONEY,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Administration Fee",
                editColFieldName: "administrationFee",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Adminsration Fee is required." },
                ],
            },
            colStyle: {
                textAlign: "right",
            },
            allowShort: false
        },        
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: false,
            },
            allowShort: false
        },
    ],
    editSettings: {
        buttons: {
            save: true,
            cancel: true,
            delete: false,
        }
    },
    allowEdit: true,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
}
